import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FileText, ExternalLink, Flag, Clock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { fmtRange } from "./TripSwitcher";

// Partner YOU page: the journey is complete (or we're looking back at a past one) → thank-you + report.
export default function JourneyCompleteCard({ navy = "#0d2340", gold = "#E0A73A" }) {
  const { config, org, isLookingBack, user } = useAuth();
  const navigate = useNavigate();
  if (!config?.id || !(config.status === "completed" || (isLookingBack && config.status === "past"))) return null;
  const ext = config.report?.external_url;
  const host = (() => { try { return new URL(ext).hostname.replace(/^www\./, ""); } catch { return ""; } })();
  const isManager = user?.role === "admin" || user?.role === "team";
  const published = !!config.report?.published;
  const canRead = isManager || published;

  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="rounded-3xl px-5 py-5 text-white relative overflow-hidden" style={{ background: "linear-gradient(135deg,#0d2340,#173a66)" }} data-testid="journey-complete-card">
      <div className="text-[11px] uppercase tracking-[0.2em] font-semibold flex items-center gap-1.5" style={{ color: gold }}><Flag className="h-3.5 w-3.5" /> {config.status === "past" ? "A journey we walked together" : "Journey complete"}</div>
      <h3 className="font-heading font-extrabold text-2xl mt-1.5 leading-tight">{config.trip_name}</h3>
      <p className="text-sm text-white/80 mt-2">{fmtRange(config.start_date, config.end_date)}. Thank you for praying, giving and walking every step of this with {org?.org_name || "us"} — here's the story of what God did.</p>
      <div className="flex flex-col gap-2 mt-4">
        {ext && (
          <a data-testid="jc-external" href={ext} target="_blank" rel="noreferrer" className="rounded-full h-11 flex items-center justify-center gap-2 font-semibold text-sm" style={{ background: gold, color: navy }}>
            <ExternalLink className="h-4 w-4" /> Read the full report{host ? ` on ${host}` : ""}
          </a>
        )}
        {canRead && (
        <button data-testid="jc-report" onClick={() => navigate(`/app/trips/${config.id}/report`)} className={`rounded-full h-11 flex items-center justify-center gap-2 font-semibold text-sm ${ext ? "border border-white/40 text-white" : ""}`} style={ext ? undefined : { background: gold, color: navy }}>
          <FileText className="h-4 w-4" /> {ext ? "In-app summary & highlights" : (isManager && !published ? "Review trip report (draft)" : "Read the trip report")}
        </button>
        )}
        {!canRead && !ext && (
          <div data-testid="jc-report-soon" className="rounded-full h-11 flex items-center justify-center gap-2 font-semibold text-sm border border-white/25 text-white/70">
            <Clock className="h-4 w-4" /> Trip report coming soon
          </div>
        )}
      </div>
    </motion.div>
  );
}
